import TravelClassSeatCountInterface from '../../interfaces/client/TravelClassSeatCount'

export default (travelClassSeatCount: TravelClassSeatCountInterface) =>
  travelClassSeatCount.availableAmountOfSeats
